// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__22Xk8","title":"AfterBackImages_title__3e8cs","images":"AfterBackImages_images__2Wr_f"};